import { Keyframes } from '@emotion/react';
import { keyframes } from '@mui/system';
//
import { CSS_EASE } from '../motion';

// ----------------------------------------------------------------------

type Timing = {
  duration: number;
  delay?: number;
  ease?: string;
};

export const riseIn = keyframes`
  from { transform: translateY(105%); }
`;

export const liftIn = keyframes`
  from { opacity: 0; transform: translateY(12px); }
`;

export const dropIn = keyframes`
  from { opacity: 0; transform: translateY(-24%); }
`;

export function entrance(
  frames: Keyframes,
  { duration, delay = 0, ease = CSS_EASE.outExpo }: Timing
) {
  return {
    '@media (prefers-reduced-motion: no-preference)': {
      animation: `${frames} ${duration}ms ${ease} ${delay}ms backwards`,
      animationPlayState: 'paused',
      'html.fonts-ready &': { animationPlayState: 'running' },
    },
  };
}
